import TileCard from "@/components/Shared/TileCard";
import clsx from "classnames";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

import BallSVG from "@/public/site-assets/svg/gray-ball.svg";
import BellSVG from "@/public/site-assets/svg/gray-bell.svg";
import CalculatorSVG from "@/public/site-assets/svg/gray-calculator.svg";
import HatSVG from "@/public/site-assets/svg/gray-hat-graduate.svg";
import QuestionSVG from "@/public/site-assets/svg/gray-question.svg";
import RulerSVG from "@/public/site-assets/svg/gray-ruler.svg";
import useTypeofPlacements from "hooks/useTypeofPlacements";

import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";

export const TypeOfPlacement = ({
  className,
  heading,
  content,
  items,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const post = useTypeofPlacements();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section ref={sectionRef} className={clsx(className, styles.root)}>
        <Container className="position-relative">
          <motion.span
            className="floating-icon"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.5, delay: 0.3 }}
          >
            <CalculatorSVG />
          </motion.span>
          <motion.span
            className="floating-icon"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.5, delay: 1 }}
          >
            <QuestionSVG />
          </motion.span>
          <motion.span
            className="floating-icon"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.5, delay: 1.3 }}
          >
            <HatSVG />
          </motion.span>
          <motion.span
            className="floating-icon"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.5, delay: 2 }}
          >
            <BallSVG />
          </motion.span>
          <motion.span
            className="floating-icon"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.5, delay: 2.3 }}
          >
            <RulerSVG />
          </motion.span>
          <motion.span
            className="floating-icon"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.5, delay: 3 }}
          >
            <BellSVG />
          </motion.span>

          <div className="position-relative z-index-2">
            {heading && <h3 className={`h3 w-100 text-center`}>{heading}</h3>}
            {content && (
              <div className={`content py-4`} dangerouslySetInnerHTML={{ __html: content }} />
            )}
            {items?.length >= 1 ? (
              <div className="inner-wrapper py-lg-5">
                {items.map((box, index) => (
                  <motion.div
                    className={`column`}
                    initial={{ opacity: 0, y: 50 }}
                    animate={isVisible ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    key={index}
                  >
                    <TileCard post={box} />
                  </motion.div>
                ))}
              </div>
            ) : (
              post?.length >= 1 && (
                <div className="inner-wrapper py-lg-5">
                  {post.map((post, index) => (
                    <motion.div
                      className={`column`}
                      initial={{ opacity: 0, y: 50 }}
                      animate={isVisible ? { opacity: 1, y: 0 } : {}}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      key={index}
                    >
                      <TileCard post={post} />
                    </motion.div>
                  ))}
                </div>
              )
            )}
          </div>
        </Container>
        {showWave && (
          <div
            className={clsx(
              "footer",
              waveDirection === "down" && "rotate",
              waveColor,
              waveBackground,
            )}
            style={{ marginTop: "-1px" }}
          >
            <FooterWave2Icon />
          </div>
        )}
      </section>
    </>
  );
};

export default TypeOfPlacement;
